<template>
  <div>
    <c-search-box @enter="getList">
      <template slot="search">
        <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3">
          <c-select
            :comboItems="useFlagItems"
            type="search"
            itemText="codeName"
            itemValue="code"
            name="useFlag"
            label="사용여부"
            v-model="searchParam.useFlag"
          ></c-select>
        </div>
      </template>
    </c-search-box>
    <div class="row">
      <div class="col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5">
        <!-- 사업장 목록 -->
        <c-table
          ref="table"
          title="LBL0003209"
          tableId="plant"
          :columns="grid.columns"
          :data="grid.data"
          :filtering="false"
          :columnSetting="false"
          :usePaging="false"
          @rowClick="rowClick"
        >
          <!-- 버튼 영역 -->
          <template slot="table-button">
            <q-btn-group outline >
              <!-- 검색 -->
              <c-btn label="LBLSEARCH" icon="search" @btnClicked="getList" />
            </q-btn-group>
          </template>
        </c-table>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-7 col-lg-7 col-xl-7">
        <q-form ref="editForm">
          <!-- 사업장 정보 -->
          <c-card title="LBL0003210" class="cardClassDetailForm">
            <template slot="card-button">
              <q-btn-group outline >
                <!-- 저장 -->
                <c-btn
                  v-if="saveEditable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="plant"
                  mappingType="PUT"
                  label="LBLSAVE"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-6">
                <!-- 회사 -->
                <c-select
                  :comboItems="companyItems"
                  type="edit"
                  itemText="companyName"
                  itemValue="mdmCompanyId"
                  name="attrVal1"
                  label="LBL0003211"
                  v-model="plant.attrVal1"
                ></c-select>
              </div>
              <div class="col-6">
                <!-- 소재지 -->
                <c-text
                  :required="true"
                  :disabled="!saveMode"
                  :editable="editable"
                  label="LBL0003212"
                  name="attrVal2"
                  v-model="plant.attrVal2">
                </c-text>
              </div>
              <div class="col-6">
                <!-- 시설구분 -->
                <c-text
                  :disabled="!saveMode"
                  :editable="editable"
                  label="LBL0003213"
                  name="attrVal3"
                  v-model="plant.attrVal3">
                </c-text>
              </div>
            </template>
          </c-card>
        </q-form>
      </div>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'plant-manage',
  data() {
    return {
      grid: {
        columns: [
          {
            name: 'companyName',
            field: 'companyName',
            // 회사명
            label: 'LBL0003204',
            align: 'left',
            style: 'width:35%',
            sortable: false,
          },
          {
            name: 'codeName',
            field: 'codeName',
            // 사업장명
            label: 'LBL0003214',
            align: 'left',
            style: 'width:35%',
            sortable: false,
          },
          {
            name: 'useFlag',
            field: 'useFlag',
            // 사용여부
            label: '사용여부',
            align: 'center',
            style: 'width:30%',
            sortable: false,
          },
        ],
        data: [],
      },
      searchParam: {
        useFlag: 'Y',
      },
      plant: {
        codeGrpCd: '',  // 코드그룹
        code: '',  // 코드
        codeName: '',  // 코드명
        codeNameEn: '',  // 코드명-영어
        codeNameJa: '',  // 코드명-일어
        codeNameZhCn: '',  // 코드명-중국어간체
        codeNameZhTw: '',  // 코드명-중국어번체
        attrVal1: null,  // 추가속성1
        attrVal2: '',  // 추가속성2
        attrVal3: '',  // 추가속성3
        attrVal4: '',  // 추가속성4
        description: '',  // 비고
        useFlag: 'Y',  // 사용여부
        sortOrder: '',  //
      },
      useFlagItems: [
        { code: 'Y', codeName: '사용' },
        { code: 'N', codeName: '미사용' },
      ],
      companyItems: [],
      editable: true,
      saveMode: false,
      isSave: false,
      listUrl: '',
      companyListUrl: '',
      detailUrl: '',
      saveUrl: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    saveEditable() {
      return this.editable && this.saveMode
    }
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.listUrl = selectConfig.mdm.plant.list.url;
      this.companyListUrl = selectConfig.mdm.company.list.url;
      this.detailUrl = selectConfig.mdm.plant.get.url;
      this.saveUrl = transactionConfig.mdm.plant.update.url;
      // code setting
      this.setCompany();
      // list scope
      this.getList();
    },
    getList() {
      this.$http.url = this.listUrl;
      this.$http.type = 'GET';
      this.$http.param = this.searchParam;
      this.$http.request((_result) => {
        this.grid.data = _result.data;
      },);
    },
    setCompany() {
      this.$http.url = this.companyListUrl;
      this.$http.type = 'GET';
      this.$http.param = {
        useFlag: 'Y',
      };
      this.$http.request((_result) => {
        this.companyItems = _result.data;
      },);
    },
    rowClick(row) {
      this.$http.url = this.$format(this.detailUrl, row.code);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.$_.extend(this.plant, _result.data);
        this.saveMode = true;
      },);
    },
    saveData() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      this.plant.code = result.data
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.getList();
      this.rowClick({ code: result.data });
    },
  }
};
</script>
